export enum LocalStorageKeys {
  UserStore = 'new-funday-userStore',
  Gender = 'sex',
  SharingKey = 'SharingKey',
  MGMCode = 'MGMCode',
  HasSeenEventCard = 'hasSeenEventCard',
  FunTVExclude = 'funTVExclude',
  FunTVExcludeNew = 'funTVExcludeNew',
  TabsCount = 'tabsCount',
  ToeicStore = 'toeicStore',
  LearningProgress = 'learningProgress',
  GiftCode = 'giftCode',
  AiChatStore = 'aiChatResult',
  AppStore = 'NewFundayAppStore',
  // 認養問卷彈窗 2026-01-01 起正式停用
  // QuestionnaireIsShowed = 'questionnaireIsShowed',
  Log = 'log',
  // 公告 - 今天不再顯示
  BulletinHideToday = 'bulletin-hide-today',
  TelemarketingQuestionnaire = 'telemarketing-q-hide-today'
}
